import React, { useContext, useState, ToastAndroid, useEffect, useRef } from "react";
import { getStoreInvoicePrinter, getUserData } from "../../utils/localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import StoreMenu from "../StoreMenu";

import qz from "qz-tray";
import ButtonLink from "../../ButtonLink";
import { getBrandStoreById } from "../../services/StoreUsers/PostStoreUsers";
import AdminMenu from "../AdminMenu";
import { formatDateNew } from "../../constants/DateUtil/DateUtil";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const B2BChallanPrint = () => {
    const { storeData, brandProfileData, userProfileData, userProfileRole } = getUserData();

    const location = useLocation();
    const { storeId, storeCustomerId, customerALLOrdersData } =
        location.state || {}; // Fallback to prevent undefined errors

    const [adminStoreData, setAdminStoreData] = useState({})

    const fetchStoreUser = () => {
        getBrandStoreById(storeId)
            .then((response) => {
                if (!response.data.error) {
                    const Res = response.data;
                    setAdminStoreData(Res);
                }
            })
            .catch((err) => {
                console.error("Error:", err);
            });
    };

    useEffect(() => {
        fetchStoreUser();
    }, [])

    let store = userProfileRole === "BY_STORE" ? storeData : adminStoreData;
    let brand = brandProfileData;
    const userProfile = userProfileData;



    const [visible, setVisible] = useState(false);
    const navigate = useNavigate();
    const data = {
        storeName: store?.storeName,
        brandName: brand?.name,
        fullAddress: store?.address?.fullAddress,
        mobileNumber: store?.mobileNo,
        email: store?.email,
    };

    const printRef = useRef();


    // PRINT
    const handlePrint = () => {
        window.print();
    };

    // PDF DOWNLOAD
    const downloadPDF = async () => {
        const input = printRef.current;

        const canvas = await html2canvas(input, {
            scale: 3,
            useCORS: true,
            logging: false,
        });

        const imgData = canvas.toDataURL("image/png");

        // A4 Size
        const pdf = new jsPDF("p", "mm", "a4");

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        // Image dimensions
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;

        // Calculate ratio
        const ratio = Math.min(
            pdfWidth / imgWidth,
            pdfHeight / imgHeight
        );

        const finalWidth = imgWidth * ratio;
        const finalHeight = imgHeight * ratio;

        // Center PDF
        const x = (pdfWidth - finalWidth) / 2;
        const y = 10;

        pdf.addImage(
            imgData,
            "PNG",
            x,
            y,
            finalWidth,
            finalHeight
        );

        pdf.save("challan.pdf");
    };


    return (
        <div className="flex-1">
            <div
                className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
                style={{
                    "--surface-0": "#1752AA",
                }}
            >
                <div className="flex-1 flex ml-3 mr-3">
                    <div className="flex-1 flex ">
                        <div className="ml-3 flex justify-content-center align-items-center">
                            <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                                <i
                                    className="pi pi-angle-left"
                                    onClick={() => {
                                        if (
                                            userProfileRole === "BY_ADMIN" ||
                                            userProfileRole === "BY_SUB_ADMIN_USER"
                                        ) {
                                            navigate("/B2BGetAllOrder", {
                                                state: {
                                                    storeIdValue: storeId,
                                                    storeCustomerId: storeCustomerId,
                                                    navigateThrough: "GoBack",
                                                },
                                            })
                                        } else {
                                            navigate("/B2BGetAllOrder", {
                                                state: {
                                                    storeCustomerId: storeCustomerId,
                                                    navigateThrough: "GoBack",
                                                },
                                            })
                                        }
                                    }}
                                    style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                                ></i>
                            </div>
                        </div>
                        <div className="flex-1 ml-5">
                            <p className="text-white text-2xl font-bold uppercase">
                              B2B Order Challan
                            </p>
                        </div>
                        {/*<div className="flex">
                            <div
                                className="mx-4 cursor-pointer"
                                onClick={printInvoiceHTML}
                            >
                                <img
                                    src={"images/printer.png"}
                                    style={{
                                        width: 35,
                                    }}
                                />
                            </div>
                        </div>*/}
                    </div>
                    <div
                        className="flex justify-content-center align-items-center cursor-pointer"
                        onClick={() => setVisible(true)}
                    >
                        <i
                            className="pi pi-bars"
                            style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
                        ></i>
                    </div>
                </div>
            </div>

            <div className="flex justify-content-between mt-2">
                <div></div>
                <div ref={printRef}
                    className="challan-container w-12 ">
                    {customerALLOrdersData?.map((item) => (
                        <div className="flex justify-content-center flex-column print-section mt-2">
                            <div className="flex justify-content-center align-items-center">
                                <p className="w-12  border-dashed border-1  "></p>
                            </div>
                            <p className="text-2xl font-medium text-center line-height-2">
                                B2B Challan
                            </p>
                            <div className="flex justify-content-center align-items-center">
                                <p className="w-7  border-dashed border-1  "></p>
                            </div>
                            <p className="text-lg font-medium text-center line-height-2">
                                {data.storeName}
                            </p>
                            <p className="text-md font-normal text-center line-height-2">
                                {data.fullAddress}
                            </p>
                            <p className="text-md font-normal text-center line-height-2">
                                {data.mobileNumber}
                            </p>
                            <p className="text-md font-normal text-center line-height-2">
                                {data.email}
                            </p>
                            <div className="flex justify-content-center align-items-center">
                                <p className="w-5  border-dashed border-1 "></p>
                            </div>
                            <p className="text-md font-medium text-center line-height-2">
                                {item.customerName}
                            </p>
                            <p className="text-md font-medium text-center line-height-2">
                                {item.customerAddress}
                            </p>
                            <p className="text-md font-medium text-center line-height-2">
                                {item.customerMobile}
                            </p>

                            <div className="flex justify-content-center align-items-center">
                                <p className="w-5  border-dashed border-1  "></p>
                            </div>
                            <div className="flex justify-content-center gap-1">
                                <p className="text-md font-medium text-left line-height-2">
                                    Challan No.:
                                </p>
                                <p className="text-md font-medium text-right line-height-2">
                                    {item.challanNo}
                                </p>
                            </div>
                            <div className="flex justify-content-between gap-5">
                                <p className="text-md font-medium text-left line-height-2">
                                    Date:
                                </p>
                                <p className="text-md font-normal text-right line-height-2">
                                    {formatDateNew(item?.createdDate)}
                                </p>
                            </div>
                            <div className="flex justify-content-between gap-5">
                                <p className="text-md font-medium text-left line-height-2">
                                    Due Date:
                                </p>
                                <p className="text-md font-normal text-right line-height-2">
                                    {item.status === "DELIVERED" || item.status === "DONE"
                                        ? formatDateNew(item.deliveredOn)
                                        : formatDateNew(item.deliveryOn)}
                                </p>
                            </div>
                            <div className="flex justify-content-between gap-5">
                                <p className="text-md font-medium text-left line-height-2">
                                    Status:
                                </p>
                                <p className="text-md font-normal text-right line-height-2">
                                    {item?.status?.replace(/_/g, " ")}
                                </p>
                            </div>

                            <div className="flex justify-content-center align-items-center">
                                <p className="w-5  border-dashed border-1  "></p>
                            </div>
                            <div className="flex">
                                <p
                                    className="text-md font-medium text-left line-height-1"
                                    style={{ flex: 2 }}
                                >
                                    Name:
                                </p>
                                <p
                                    className="text-md font-medium text-left line-height-1"
                                    style={{ flex: 2 }}
                                >
                                    Service
                                </p>
                                <p className="flex-1 text-md font-medium text-right line-height-1">
                                    Qty
                                </p>
                                <p className="flex-1 text-md font-medium text-right line-height-1">
                                    IC
                                </p>
                            </div>
                            {item?.orderItem?.map((itemList) => (
                                <div className="flex " key={itemList.id}>
                                    <p
                                        className="text-md font-normal text-left line-height-1"
                                        style={{ flex: 2 }}
                                    >
                                        {itemList.garmentAlias !== ""
                                            ? itemList.garmentAlias.replace(/_/g, " ")
                                            : itemList.garmentName.replace(/_/g, " ")}
                                    </p>
                                    <p
                                        className="text-md font-normal text-left line-height-1"
                                        style={{ flex: 2 }}
                                    >
                                        {itemList.addOns.map((addOnItem, i) => (
                                            <p
                                                key={i}
                                                className="text-md text-left line-height-1 font-normal"
                                            >
                                                {addOnItem.serviceName}
                                            </p>
                                        ))}
                                    </p>

                                    <p className="flex-1 text-md font-normal text-left line-height-1">
                                        {itemList.bookingType === "PackageBooking" ? <p
                                            className="text-md text-right line-height-1 font-normal"
                                        > - </p> :
                                            itemList.addOns.map((addOnItem, i) => (
                                                <p
                                                    key={i}
                                                    className="text-md text-right line-height-1 font-normal"
                                                >
                                                    {addOnItem.count + addOnItem.countGram}{" "}
                                                    {addOnItem.serviceUnit === "Qty"
                                                        ? " Pcs"
                                                        : addOnItem.serviceUnit}
                                                </p>
                                            ))}
                                    </p>
                                    <p className="flex-1 text-md font-normal text-right line-height-1">
                                        {itemList.itemGarmentCount}
                                    </p>
                                </div>
                            ))}

                            <div className="flex ">
                                <p
                                    className="text-md font-medium text-left line-height-2"
                                    style={{ flex: 2 }}
                                >
                                    Total Garments :
                                </p>
                                <p
                                    className="text-md font-medium text-left line-height-2"
                                    style={{ flex: 2 }}
                                ></p>
                                {/* <p className="text-md font-medium text-right" style={{ flex: 1 }}>
                                        {totalGarmentQrCount}
                                    </p> */}
                                <p
                                    className="text-md font-medium text-right line-height-2"
                                    style={{ flex: 1 }}
                                >
                                    {item.itemGarmentCount}
                                </p>
                            </div>
                            <div className="flex justify-content-between gap-5">
                                <p className="text-md font-medium text-left line-height-2">
                                    Grand Total:
                                </p>
                                <p className="text-md font-medium text-right line-height-2">
                                    {item.grandTotal}
                                </p>
                            </div>
                            <div className="flex justify-content-between gap-5">
                                <p className="text-md font-medium text-left line-height-2">
                                    Balance Amount:
                                </p>
                                <p className="text-md font-medium text-right line-height-2">
                                    {item.balanceAmount}
                                </p>
                            </div>
                            <div className="flex justify-content-between gap-5">
                                <p className="text-md font-medium text-left line-height-2">
                                    Order Source:
                                </p>
                                <p className="text-md font-medium text-right line-height-2">
                                    {item.orderSource}
                                </p>
                            </div>

                            <div className="flex justify-content-center align-items-center">
                                <p className="w-7  border-dashed border-1 "></p>
                            </div>
                            <p className="text-xl font-medium text-center">
                                Powered By {data.brandName}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="ml-4 cursor-pointer" onClick={handlePrint}>
                    <img
                        src={"Icons/printer.png"}
                        style={{
                            width: 65,
                        }}
                    />
                </div>


            </div>
            {/* Menu component */}

            {(userProfileRole === "BY_STORE") ?
                <StoreMenu setVisible={setVisible} visible={visible} />
                :
                <AdminMenu setVisible={setVisible} visible={visible} />
            }
            <ButtonLink />
            <style>
                {`
                    .challan-container{
                       width:100%;
                        max-width:900px;
                        margin:auto;
                        background:white;
                        padding:20px;
                    }

                    .print-section{
                        page-break-after:always;
                        font-size:12px;
                    }

                    .row{
                        display:flex;
                        justify-content:space-between;
                        margin:4px 0;
                    }

                    .table-header,
                    .table-row{
                        display:grid;
                        grid-template-columns:2fr 2fr 1fr 1fr;
                        gap:5px;
                        margin-top:5px;
                    }

                    .text-center{
                        text-align:center;
                    }

                    @media print {

                        body *{
                            visibility:hidden;
                        }

                        .challan-container,
                        .challan-container *{
                            visibility:visible;
                        }

                        .challan-container{
                            position:absolute;
                            left:0;
                            top:0;
                            width:100%;
                        }

                        @page{
                            size:80mm auto;
                            margin:2mm;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default B2BChallanPrint;
